import React, { ReactNode } from "react";

import { Box } from "@mui/material";

interface IgTabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

/**
 * @see HTMLDivElement
 * @see Box
 */
export const IgTabPanel = (props: IgTabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tab-panel"
      hidden={value !== index}
      id={`ig-tab-panel-${index}`}
      aria-labelledby={`ig-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <>{children}</>
        </Box>
      )}
    </div>
  );
};
